module.exports = __webpack_public_path__ + "img/slide-5.7567ddf6.jpeg";